export default "__VITE_ASSET__DeNQ$oT$__"